<template>
  <div class="banner">
    <div class="content">
      <div class="banner_left">
        <h2>最高30万元免押额度</h2>
        <p class="title_er">一次认证 循环使用</p>
        <div class="fenbox">
          <div class="down_box">
            <p>
              <img src="/static/img/2@3x.png" alt="Android下载">
              <a href="https://a.app.qq.com/o/simple.jsp?pkgname=com.dazuhang.app">Android下载</a>
            </p>
            <p>
              <img src="/static/img/1@3x.png" alt="AppStore下载">
              <a href="https://itunes.apple.com/cn/app/id1460354999?mt=8">AppStore下载</a>
            </p>
          </div>
          <div class="erweima">
            <img src="../../static/img/code.png" alt="摄影器材租赁APP下载二维码">
          </div>
        </div>
      </div>
      <div class="banner_right">
        <img src="/static/img/zupin_bg.png" alt="一次认证 循环使用">
      </div>
    </div>
  </div>
</template>

<script>
import { download } from "../api/download/download";
export default {
  name: "download",
  metaInfo() {
    return {
      title: "大租行-摄影器材租赁APP下载页",
      meta: [
      {
        name: 'keywords',
        content: '摄影器材租赁APP下载,单反相机租赁,摄像机租赁,镜头租赁,相机租用,摄像机租用,直播设备租赁,录音设备租赁,灯光器材租赁,航拍,摇臂,导播,单反,镜头,灯光,录音设备,摄影人员'
      },
      {
        name: 'description',
        content:'摄影器材租赁APP下载,大租行是国内专业为企业和个人提供影视器材租赁的互联网平台，可供租赁的设备有:单反相机、镜头、航拍无人机、gopro摄像机、稳定器、直播设备，影视灯光、录音话筒、轨道、摇臂等专业影视设备。'
      }
    ]
    };
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html {
  background: linear-gradient(to right, #fd314a, #ffd778);
}
.banner {
  /* height: 600px; */
  width: 100%;
  background: linear-gradient(to right, #fd314a, #ffd778);
}
.content {
  /* width: 80%; */
  max-width: 1400px;
  min-width: 1200px;
  display: flex;
  padding: 150px 100px;
  margin: 0 auto;
}
.banner_left {
  width: 50%;
}
.banner_left h2 {
  font-size: 50px;
  font-weight: bold;
  color: #fff;
}
.title_er {
  font-size: 30px;
  font-weight: 600;
  color: #fff;
  margin-top: 20px;
}
.fenbox {
  display: flex;
}
.down_box p {
  width: 240px;
  height: 78px;
  border: 3px solid #fff;
  border-radius: 4px;
  padding: 20px 30px;
  margin-top: 20px;
  display: flex;
  align-items: center;
}
.down_box p img {
  width: 40px;
  height: 50px;
}
.down_box p a {
  font-size: 20px;
  padding-left: 5px;
  color: #fff;
}
.erweima {
  border-radius: 8px;
  margin-left: 95px;
  margin-top: 30px;
}
.erweima img {
  width: 150px;
  height: 150px;
}
.banner_right {
  width: 458px;
  height: 310px;
  margin-left: 46px;
}
.banner_right img {
  width: 100%;
  height: 310px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/download.vue